/* global axios */

import ApiClient from '../ApiClient';

// Per-campaign delivery report. Server authorization (admin or
// campaign_manage) is authoritative; this client only mirrors it.
class TeletelCampaignReportsAPI extends ApiClient {
  constructor() {
    super('campaign-reports', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  export() {
    return axios.get(`${this.url}/export`, { responseType: 'blob' });
  }
}

export default new TeletelCampaignReportsAPI();
